import React, { useState } from "react";
import variables from "../../../../constants/assets/variables";
import styled from "styled-components";

const TextLimiter = ({ text, limit, center = true }) => {
  const [showMore, setShowMore] = useState(false);
  const parsedText = text.toString();
  const textStyles = "text-left break-words w-max max-w-[300px]";

  return (
    <TextLimiterDiv>
      {parsedText.length > limit ? (
        <TextPreview>
          {showMore ? text : `${parsedText.substring(0, limit)}...`}
          <TextShowMore onClick={() => setShowMore(!showMore)}>
            {showMore ? " Show less" : " Show more"}
          </TextShowMore>
        </TextPreview>
      ) : (
        <p className={textStyles}>{text}</p>
      )}
    </TextLimiterDiv>
  );
};

export default TextLimiter;

const TextLimiterDiv = styled.div`
  font-size: 12px;
`;

const TextPreview = styled.p`
  text-align: left;
  overflow-wrap: break-word;
  max-width: 300px;
  width: max-content;
`;

const TextShowMore = styled.span`
  cursor: pointer;
  color: ${variables.blue500};
  font-size: 12px;
`;
